<template>
  <div class="container monitoring-list-container">
    <v-row class="page-header">
      <v-col class="page-title" cols="12">
        <v-toolbar-title :class="['font-bold', $vuetify.theme.dark ? '' : 'black--text']">
          {{ $t('lbl.monitoring.page_header') }}
        </v-toolbar-title>
      </v-col>
    </v-row>
    <v-row
      class="mb-0 custom-form-control custom-form-control-type-2 custom-form-control-type-4 custom-figma-1"
    >
      <v-col cols="12" class="search-conditions-display">
        <div class="pl-0 pt-0 pb-0 collapse-search-conditions hide">
          <v-btn
            class="btn btn-top"
            color="primary"
            @click.native="displaySearchConditions('collapse')"
          >
            <v-icon x-small class="mr-2">fa fa-chevron-up</v-icon>
            {{ $t('btn.common.collapseConditions') }}
          </v-btn>
        </div>
        <div class="pl-0 pt-0 pb-0 expand-search-conditions">
          <v-btn
            class="btn btn-top"
            color="primary"
            @click.native="displaySearchConditions('expand')"
          >
            <v-icon x-small class="mr-2">fa fa-chevron-down</v-icon>
            {{ $t('btn.common.expandConditions') }}
          </v-btn>
        </div>
      </v-col>
      <v-col cols="12" xl="8" lg="8" md="12">
        <v-row>
          <v-col
            cols="12"
            class="comm-header-col data-query-section pb-0 pt-0 mt-0 custom-field-combo custom-figma-1"
          >
            <v-row class="pt-0 pb-0 mt-0 mb-2">
              <v-col
                v-show="$cookies.get('user-admin-yn') === 'Y'"
                cols="12"
                lg="2"
                md="4"
                class="pt-0 pb-0 mb-0"
              >
                <div class="d-inline-flex-2 area-condition">
                  <v-autocomplete
                    v-model="company"
                    :label="$t('lbl.common.conditionSearch.selectCompany')"
                    :items="customerItem"
                    @change="initialize"
                    width="60px"
                    dense
                    filled
                    hide-details
                  ></v-autocomplete>
                </div>
              </v-col>
              <v-col
                cols="12"
                :lg="$cookies.get('user-admin-yn') === 'Y' ? '2' : '3'"
                md="4"
                class="pt-0 pb-0 pr-0"
              >
                <v-text-field
                  v-model="senderId"
                  :label="$t('lbl.common.conditionSearch.findbySender')"
                  @keyup.enter="initialize"
                  class="custom-selectbox"
                  dense
                  filled
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                :lg="$cookies.get('user-admin-yn') === 'Y' ? '2' : '3'"
                md="4"
                class="pt-0 pb-0 pr-24px"
              >
                <v-text-field
                  v-model="recipientId"
                  :label="$t('lbl.common.conditionSearch.findbyReceiver')"
                  @keyup.enter="initialize"
                  class="custom-selectbox"
                  dense
                  filled
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" lg="2" md="4" class="pt-0 pb-0">
                <v-autocomplete
                  ref="auto"
                  v-model="message"
                  :items="EDIMesList"
                  :label="
                    isFocus && (message || []).length > 0
                      ? ' '
                      : $t('lbl.common.conditionSearch.selectMessage')
                  "
                  @focus="isFocus = true"
                  @blur="isFocus = false"
                  @change="changeMsgCode"
                  :search-input.sync="search"
                  class="custom-selectbox custom-auto-message"
                  item-text="text"
                  item-value="value"
                  dense
                  filled
                  hide-details
                  multiple
                  chips
                  small-chips
                >
                  <template v-slot:item="{ item, on, attrs }">
                    <v-list-item v-bind="attrs" v-on="on" :key="item.value">
                      <v-list-item-action>
                        <v-checkbox :input-value="attrs.inputValue" color="primary" />
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ item.text }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                  <template v-slot:selection="{ item, index }">
                    <v-chip
                      v-if="index < 3"
                      small
                      @mousedown.stop.prevent
                      @click="
                        removeChip(index);
                        changeMsgCode();
                      "
                    >
                      {{ item.value }}
                    </v-chip>
                    <v-tooltip top v-if="index === 3">
                      <template v-slot:activator="{ on, attrs }">
                        <v-chip v-bind="attrs" v-on="on" small> +{{ message.length - 3 }} </v-chip>
                      </template>
                      <span>
                        {{ message.slice(3).join(', ') }}
                      </span>
                    </v-tooltip>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12" lg="2" md="4" class="pt-0 pb-0">
                <v-autocomplete
                  v-model="direction"
                  :label="$t('lbl.common.conditionSearch.selectDirection')"
                  :items="directions"
                  @change="initialize"
                  class="custom-selectbox"
                  dense
                  filled
                  hide-details
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" lg="2" md="4" class="pt-0 pb-0">
                <v-autocomplete
                  v-model="status"
                  dense
                  class="custom-selectbox"
                  :label="$t('lbl.common.conditionSearch.selectStatus')"
                  :items="statuses"
                  @change="initialize"
                  filled
                  hide-details
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" xl="4" lg="4" md="12">
        <v-row>
          <v-col
            class="comm-header-col date-query-section pr-0 pb-0 pt-0 mt-0 custom-figma-1"
            cols="12"
          >
            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <v-menu
                ref="fromdate_menu"
                v-model="fromDate"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="fromDateData"
                    :disabled="!dateCond"
                    :class="['date-text', $vuetify.theme.dark ? '' : 'font-semibold']"
                    append-icon="mdi-calendar"
                    dense
                    solo
                    @keypress="formatDate('from', $event)"
                    @change="changeDate('from')"
                    @click:append="on.click"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="fromDateData"
                  :disabled="!dateCond"
                  :max="getMaxDate"
                  @input="
                    fromDate = false;
                    changeDate('from');
                  "
                  class="date-period-picker"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="fromdate_menu = false">Cancel</v-btn>
                  <v-btn text color="primary" @click="$refs.fromdate_menu.save(fromDateData)"
                    >OK</v-btn
                  >
                </v-date-picker>
              </v-menu>
            </div>
            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <v-menu
                ref="fromtime_menu"
                v-model="fromTime"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="fromTimeData"
                    :disabled="!dateCond"
                    :class="['time-text', $vuetify.theme.dark ? '' : 'font-semibold']"
                    append-icon="mdi-clock-outline"
                    dense
                    solo
                    @keypress="formatTime('from', $event)"
                    @change="validateTimeInput('from')"
                    @click:append="on.click"
                  ></v-text-field>
                </template>
                <v-time-picker
                  :disabled="!dateCond"
                  v-model="fromTimeData"
                  class="time-picker"
                  scrollable
                  format="ampm"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="fromtime_menu = false">{{
                    $t('btn.common.cancel')
                  }}</v-btn>
                  <v-btn text color="primary" @click="$refs.fromtime_menu.save(fromTimeData)">{{
                    $t('btn.common.ok')
                  }}</v-btn>
                </v-time-picker>
              </v-menu>
            </div>
            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <v-menu
                ref="todate_menu"
                v-model="toDate"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="toDateData"
                    :disabled="!dateCond"
                    :class="['date-text', $vuetify.theme.dark ? '' : 'font-semibold']"
                    append-icon="mdi-calendar"
                    dense
                    solo
                    @keypress="formatDate('to', $event)"
                    @change="changeDate('to')"
                    @click:append="on.click"
                  ></v-text-field>
                </template>
                <v-date-picker
                  class="date-period-picker"
                  :allowed-dates="allowedDates"
                  v-model="toDateData"
                  :disabled="!dateCond"
                  @input="
                    toDate = false;
                    changeDate('to');
                  "
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="todate_menu = false">{{
                    $t('btn.common.cancel')
                  }}</v-btn>
                  <v-btn text color="primary" @click="$refs.todate_menu.save(toDateData)">{{
                    $t('btn.common.ok')
                  }}</v-btn>
                </v-date-picker>
              </v-menu>
            </div>
            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <v-menu
                ref="totime_menu"
                v-model="toTime"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="toTimeData"
                    :disabled="!dateCond"
                    :class="['time-text', $vuetify.theme.dark ? '' : 'font-semibold']"
                    append-icon="mdi-clock-outline"
                    dense
                    solo
                    @keypress="formatTime('to', $event)"
                    @change="validateTimeInput('to')"
                    @click:append="on.click"
                  ></v-text-field>
                </template>
                <v-time-picker
                  :disabled="!dateCond"
                  v-model="toTimeData"
                  class="time-picker"
                  scrollable
                  format="ampm"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="totime_menu = false">{{
                    $t('btn.common.cancel')
                  }}</v-btn>
                  <v-btn text color="primary" @click="$refs.totime_menu.save(toTimeData)">{{
                    $t('btn.common.ok')
                  }}</v-btn>
                </v-time-picker>
              </v-menu>
            </div>
            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <v-btn
                class="btn-width-1 btn btn-top btn-search"
                color="primary"
                @click.native="initialize"
              >
                <v-icon x-small class="mr-2">fa fa-search</v-icon>
                {{ $t('btn.common.search') }}
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" class="pt-0 pb-0 mb-0"> </v-col>
    </v-row>
    <v-expand-transition>
      <v-row
        class="mb-0 custom-form-control custom-form-control-type-2 custom-form-control-type-4 custom-figma-1"
      >
        <v-col
          class="comm-header-col data-query-section pb-0 pt-0 pr-0 pl-0 mt-0 custom-field-combo custom-figma-1"
          cols="12"
          lg="12"
          md="12"
        >
          <v-row class="pt-0 pb-0 mt-0 mb-4 pl-3 pr-3">
            <v-col cols="12" :xl="isAddFilter ? 8 : 8" :lg="isAddFilter ? 8 : 8" md="12">
              <v-row class="pt-0 pb-0 mt-0">
                <v-col
                  cols="12"
                  :xl="isAddFilter ? 2 : 2"
                  :lg="isAddFilter ? 2 : 2"
                  :md="isAddFilter ? 2 : 2"
                  class="pt-0 pb-0 mb-0"
                >
                  <v-autocomplete
                    v-model="searchKeyBy1"
                    :class="['custom-selectbox', $vuetify.theme.dark ? '' : 'font-semibold']"
                    :label="
                      $vuetify.theme.dark ? $t('lbl.common.conditionSearch.selectSearchKey') : ''
                    "
                    :items="searchKeyByItems"
                    @change="changeKeyBy"
                    dense
                    filled
                    hide-details
                  ></v-autocomplete>
                </v-col>
                <v-col
                  cols="12"
                  :xl="isAddFilter ? 4 : 4"
                  :lg="isAddFilter ? 4 : 4"
                  :md="isAddFilter ? 4 : 4"
                  class="flex pt-0 pb-0 mb-0"
                >
                  <div class="flex-1">
                    <v-text-field
                      v-model="searchKeyByTxt1"
                      :label="$t('lbl.common.conditionSearch.inputSearchKey')"
                      v-on:keyup.enter="initialize"
                      dense
                      filled
                      hide-details
                    >
                      <template v-slot:append>
                        <v-icon @click="openInputSearchKeyWindow()" size="18">mdi-plus</v-icon>
                      </template>
                    </v-text-field>
                  </div>
                  <div
                    :class="[
                      searchKeyBy1 == 'processId' ||
                      searchKeyBy1 == 'inputFileName' ||
                      searchKeyBy1 == 'outputFileName'
                        ? 'hidden'
                        : 'filter-icon-add',
                    ]"
                    @click="openAddFilter()"
                  >
                    <icon-svg
                      :size="18"
                      :stroke="$vuetify.theme.dark ? '#D8D8D8' : '#6F90AF'"
                      iconName="filter-add"
                    />
                  </div>
                </v-col>
                <v-col v-show="isAddFilter" cols="12" lg="2" md="4" class="pt-0 pb-0 mb-0">
                  <v-autocomplete
                    v-model="searchKeyBy2"
                    :label="$t('lbl.common.conditionSearch.selectSearchKey')"
                    :items="filteredOptions"
                    @change="initialize"
                    dense
                    filled
                    hide-details
                  ></v-autocomplete>
                </v-col>
                <v-col
                  v-show="isAddFilter"
                  cols="12"
                  lg="4"
                  md="4"
                  class="flex pt-0 pb-0 mb-0 pr-3"
                >
                  <div
                    class="flex-1"
                    :style="[$vuetify.theme.dark ? { 'padding-right': '1px' } : {}]"
                  >
                    <v-text-field
                      v-model="searchKeyByTxt2"
                      :label="$t('lbl.common.conditionSearch.inputSearchKey')"
                      v-on:keyup.enter="initialize"
                      @keydown="changeKeyBy2"
                      dense
                      filled
                      hide-details
                    ></v-text-field>
                  </div>
                  <div class="filter-icon-add" @click="deleteAddFilter()">
                    <icon-svg
                      :size="18"
                      :stroke="$vuetify.theme.dark ? '#D8D8D8' : '#6F90AF'"
                      iconName="delete-new"
                    />
                  </div>
                </v-col>
                <v-col
                  v-show="
                    !isAddFilter &&
                      ($cookies.get('login-user-comp-id') === $cookies.get('ownr-id') ||
                        Number($cookies.get('use-grade')) === 9)
                  "
                  cols="12"
                  lg="4"
                  md="4"
                  xl="4"
                  class="pt-0 pb-0 mb-0"
                >
                  <v-autocomplete
                    v-model="processSetupId"
                    class="custom-selectbox"
                    :label="$t('lbl.common.conditionSearch.selectSetUpName')"
                    :items="getProcessSetupNameList"
                    @change="initialize"
                    dense
                    filled
                    hide-details
                  ></v-autocomplete>
                </v-col>
                <v-col v-show="!isAddFilter" cols="12" lg="2" md="2" xl="2" class="pt-0 pb-0 mb-0">
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" xl="4" lg="4" md="12" class="flex align-center">
              <div
                v-show="
                  isAddFilter &&
                    ($cookies.get('login-user-comp-id') === $cookies.get('ownr-id') ||
                      Number($cookies.get('use-grade')) === 9)
                "
                class="moni-setup-name mr-1"
              >
                <v-autocomplete
                  v-model="processSetupId"
                  class="custom-selectbox flex-1"
                  :label="$t('lbl.common.conditionSearch.selectSetUpName')"
                  :items="getProcessSetupNameList"
                  @change="initialize"
                  dense
                  filled
                  hide-details
                ></v-autocomplete>
              </div>
              <div class="flex pt-0 pb-0">
                <v-checkbox
                  v-model="dateCond"
                  :disabled="checkSearchKeyBy"
                  :style="[$vuetify.theme.dark ? '' : 'border: none;']"
                  class="mt-0 pt-0"
                  hide-details
                  @change="changeDateTime"
                  dense
                  solo
                ></v-checkbox>
                <span
                  class="all-code-label ml-2"
                  style="position: relative; top: -2px; left: -12px"
                  >{{ $t('msg.common.applyDateCond') }}</span
                >
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-expand-transition>
    <v-row class="custom-pagination-figma-v3-first">
      <v-col class="page-control-content page-control-bg transaction-pagi">
        <v-row>
          <v-col lg="8" md="7">
            <v-row>
              <v-col class="page-control-bg" cols="9">
                <v-btn
                  @click="downloadExcel"
                  :disabled="!$auth.manage"
                  x-small
                  class="btn-height-custom btn-excel mb-0"
                >
                  {{ $t('btn.monitoring.excel') }}
                </v-btn>
                <v-btn
                  @click="downOriginMulti"
                  :disabled="
                    !$auth.manage ||
                      Number($cookies.get('use-grade')) !== 9 ||
                      !selectItems.length > 0
                  "
                  x-small
                  class="btn-height-custom btn-excel mb-0"
                >
                  {{ $t('btn.monitoring.originFiles') }}
                </v-btn>
              </v-col>
              <v-col cols="3" class="page-control-bg text-right mr-0 pr-0">
                <v-btn
                  @click="reProcesMulti"
                  :disabled="
                    !$auth.manage || Number($cookies.get('use-grade')) !== 9 || checkReprocess
                  "
                  x-small
                  class="btn-height-custom btn-add mb-0 mr-0"
                >
                  {{ $t('btn.monitoring.reMulti') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col lg="4" md="5" class="filter-search">
            <v-row>
              <v-col class="mr-0 pr-0" md="5">
                <v-select
                  v-model="searchBy"
                  :placeholder="$t('lbl.common.searchTypePlaceHolder')"
                  height="40"
                  hide-details
                  dense
                  solo
                  @change="onFilterTransactionLog"
                  :items="searchByItems"
                  class="search-by data-table-select-box custom-selectbox flat-file-selectbox mr-0"
                ></v-select>
              </v-col>
              <v-col class="ml-0 pl-0" cols="12" md="7">
                <v-text-field
                  v-model="searchByTxt"
                  heigth="40"
                  append-icon="fa fa-search"
                  :placeholder="$t('lbl.common.searchPlaceHolder')"
                  hide-details
                  dense
                  solo
                  class="data-table-filter-text-field search-button-data-analysis-table flat-file"
                  @input="onFilterTransactionLog"
                  @click:append="onFilterTransactionLog"
                  v-on:keyup.enter="onFilterTransactionLog"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <system-progress :sysloading="isLoading" :sysloadingTitle="sysloadingTitle"></system-progress>
      <v-col cols="12" class="pt-0 pb-0 ve-table-style">
        <ve-table
          ref="ve-monitor-list"
          row-key-field-name="KEY"
          :class="['ve-table-list']"
          :scroll-width="0"
          :columns="headers"
          :table-data="listData"
          :row-style-option="rowStyleOption"
          :cellSelectionOption="cellSelectionOption"
          :checkbox-option="checkboxOption"
          :columnHiddenOption="columnHiddenOption"
          :column-width-resize-option="columnWidthResizeOption"
          :cell-style-option="cellStyleOption"
        ></ve-table>
        <div v-show="listData && listData.length === 0" class="ve-empty-data">
          {{ $t('lbl.veTable.empty') }}
        </div>
      </v-col>
    </v-row>
    <v-row v-show="this.$store.getters.totalCnt > 0" class="custom-pagination-figma-v3-last">
      <v-col class="page-control-content page-control-bg transaction-pagi">
        <v-row>
          <v-col lg="12" md="12">
            <v-row>
              <v-col class="page-control-bg text-left pa-0" cols="6">
                <div class="custom-pagi-selectbox">
                  <v-select
                    @change="handlePageSizeChange"
                    v-model="itemsPerPage"
                    hide-details
                    dense
                    solo
                    :items="rowPerPage"
                    class="data-table-select-box custom-selectbox mr-0 page-flat-file-selectbox"
                  ></v-select>
                </div>
              </v-col>
              <v-col class="page-control-bg text-right pa-0" cols="6">
                <div class="page-showing">
                  <v-label
                    >{{ itemsPerPage * (page - 1) + 1 }} ~
                    {{ itemsPerPage * (page - 1) + listData.length }} of
                    {{ this.$store.getters.totalCnt }}</v-label
                  >
                </div>
                <button
                  type="button"
                  @click="handlePageChange(1)"
                  :class="[
                    'custom-btn-first-last-paging',
                    page == 1
                      ? ' v-pagination__navigation--disabled'
                      : `${$vuetify.theme.dark ? '' : 'white'}`,
                  ]"
                >
                  <div class="ml-2 pr-2 d-inline">
                    <span>
                      <i class="fa fa-sm fa-step-backward"></i>
                    </span>
                  </div>
                </button>
                <button
                  type="button"
                  @click="changePageByTextbox(-1)"
                  :class="[
                    'mr-3 custom-btn-first-last-paging',
                    page - 1 < 1
                      ? ' v-pagination__navigation--disabled'
                      : `${$vuetify.theme.dark ? '' : 'white'}`,
                  ]"
                >
                  <div class="ml-2 pr-2 d-inline">
                    <span>
                      <i class="fa fa-lg fa-caret-left"></i>
                    </span>
                  </div>
                </button>
                <v-text-field
                  v-model="pageEnter"
                  hide-details
                  dense
                  solo
                  class="data-table-filter-text-field custom-pagi-selectbox page-selectbox"
                  @keyup.enter="changePageByTextbox(0)"
                ></v-text-field>
                <label>/ {{ pageCount }}</label>
                <button
                  type="button"
                  @click="changePageByTextbox(1)"
                  :class="[
                    'ml-3 custom-btn-first-last-paging',
                    page + 1 > pageCount
                      ? ' v-pagination__navigation--disabled'
                      : `${$vuetify.theme.dark ? '' : 'white'}`,
                  ]"
                >
                  <div class="mr-2 pl-2 d-inline">
                    <span>
                      <i class="fa fa-lg fa-caret-right"></i>
                    </span>
                  </div>
                </button>
                <button
                  type="button"
                  @click="handlePageChange(pageCount)"
                  :class="[
                    'custom-btn-first-last-paging',
                    page == pageCount
                      ? ' v-pagination__navigation--disabled'
                      : `${$vuetify.theme.dark ? '' : 'white'}`,
                  ]"
                >
                  <div class="mr-2 pl-2 d-inline">
                    <span>
                      <i class="fa fa-sm fa-step-forward"></i>
                    </span>
                  </div>
                </button>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <div v-for="dialog in dialogs" :key="dialog.id" class="dialogs">
      <monitoringBizFileViewWindow
        v-if="dialog.type == 'monitoringBizFileViewWindow'"
        :id="dialog.id"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        :fileViewInfo="tempItem"
        :outputBizFileLink="tmpOutputBizFileLink"
      ></monitoringBizFileViewWindow>
      <inputSearchKeyWindow
        v-if="dialog.type == 'inputSearchKeyWindow'"
        :id="dialog.id"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        :searchKeyVal="tempItem"
        @select-ok="setSearchKeyByTxt($event)"
      ></inputSearchKeyWindow>
    </div>
    <dialogWindow
      ref="Validation"
      :info="checkDialogTitle"
      size="max"
      :detail="checkDialogInfo"
      :color="checkDialogColor"
      @select-ok="closeDialog()"
    ></dialogWindow>
    <dialogWindow
      ref="excelValidation"
      size="max"
      :detail="excelWarningContent"
      color="validation"
    ></dialogWindow>
    <dialogWindow
      ref="reProcess"
      size="max"
      :detail="reProcessContent"
      color="success"
    ></dialogWindow>
    <dialogWindow
      ref="validateDate"
      size="max"
      :detail="$t('msg.common.validateDate')"
      color="validation"
    ></dialogWindow>
  </div>
</template>

<script>
import monitoringBizFileViewWindow from '@/vue-caas/views/monitoring/MonitoringBizFileView.vue';
import inputSearchKeyWindow from '@/vue-caas/views/monitoring/InputSearchKeyView.vue';
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import { deleteDateFormatStr } from '@/vue-dlb/utils/util';
import { getAppliedTimeZone } from '@/vue-dlb/utils/util';
import { dateValidation } from '@/vue-dlb/utils/util';
import config from '@/vue-caas/config/config.js';
import { mapState } from 'vuex';
import $ from 'jquery';
import { openWindow } from '@/vue-dlb/utils/window-opener';
import IconSvg from '@/vue-caas/components/IconBase.vue';

import SystemProgress from '@/vue-dlb/components/SystemProgress.vue';
const moment = require('moment');

export default {
  components: {
    monitoringBizFileViewWindow,
    inputSearchKeyWindow,
    dialogWindow,
    SystemProgress,
    IconSvg,
  },

  data() {
    return {
      dateCond: true,
      checkSearchKeyBy: false,
      dateTimeFormat: '',
      dialogFileView: false,
      dialogErrView: false,
      dialogs: [],
      dialogId: 1,
      dialog: false,
      arrLayoutDialog: [],
      headers: [
        {
          field: '',
          key: 'CHECK',
          type: 'checkbox',
          title: '',
          width: 40,
          align: 'center',
          fixed: 'left',
        },
        {
          field: 'INDEX',
          title: this.$t('tbl.common.columnNo'),
          key: 'INDEX',
          width: 40,
          fixed: 'left',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (this.page - 1) * this.itemsPerPage + rowIndex + 1;
          },
        },
        {
          field: 'record',
          title: 'Sender',
          key: 'senderId',
          width: 110,
          fixed: 'left',
          renderBodyCell: ({ row, column, rowIndex }, h) => (
            <font class="sender-col">{row.record.messageInfo.senderId}</font>
          ),
        },
        {
          field: 'record',
          title: 'Receiver',
          key: 'recipientId',
          width: 110,
          fixed: 'left',
          renderBodyCell: ({ row, column, rowIndex }, h) => (
            <font class="sender-col">{row.record.messageInfo.recipientId}</font>
          ),
        },
        {
          field: 'record',
          title: 'Message',
          key: 'messageName',
          width: 110,
          fixed: 'left',
          renderBodyCell: ({ row, column, rowIndex }, h) => (
            <font class="sender-col">{row.record.messageInfo.messageName}</font>
          ),
        },
        {
          field: 'direction',
          title: 'Direction',
          key: 'direction',
          width: 120,
          renderBodyCell: ({ row, column, rowIndex }, h) => (
            <font>{this.directionText(row.direction)}</font>
          ),
        },
        {
          field: 'transactionCode',
          title: 'Status',
          key: 'transactionCode',
          width: 120,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            let trans = row.transactionCode;
            let reproc = row.reprocessState;
            let procs = row.processCode;
            return trans.indexOf('FAIL') !== -1 ? (
              <font
                class='cursor-pointer font-semibold'
                color={this.statusColor(trans, procs)}
                on-click={() => this.openMonitoringStateViewWindow(row)}
              >
                {this.statusText(trans, reproc, procs)}
              </font>
            ) : (
              <font
                class='cursor-pointer font-semibold'
                color={this.statusColor(trans, procs)}
                on-click={() => this.openMonitoringStateViewWindow(row)}
              >
                {this.statusText(trans, reproc, procs)}
              </font>
            );
          },
        },
        {
          field: 'recvTimestamp',
          title: 'Received Date',
          key: 'recvTimestamp',
          width: 180,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              row.record.transOutput !== undefined && (
                <font>{this.applyGmtTimeZone(row.record.recvTimestamp)}</font>
              )
            );
          },
        },
        {
          field: 'transTimestamp',
          title: 'Translation Date',
          key: 'transTimestamp',
          width: 180,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              row.record.transOutput !== undefined && (
                <font>{this.applyGmtTimeZone(row.record.transTimestamp)}</font>
              )
            );
          },
        },
        {
          field: 'sentTimestamp',
          title: 'Sent Date',
          key: 'sentTimestamp',
          width: 180,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              row.record.transOutput !== undefined && (
                <font>{this.applyGmtTimeZone(row.record.sentTimestamp)}</font>
              )
            );
          },
        },
        {
          field: 'fileLink',
          title: 'Processed File',
          key: 'fileLink',
          width: 140,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              row.record.transInput !== undefined &&
              row.record.transOutput !== undefined && (
                <a
                  class='link-file-text cursor-pointer layout-col'
                  on-click={() => this.openMonitoringFileViewWindow(row)}
                >
                  {this.$t('btn.common.view')}
                </a>
              )
            );
          },
        },
        {
          field: 'processId',
          title: 'Process ID',
          key: 'processId',
          width: 230,
          renderBodyCell: ({ row, column, rowIndex }, h) => <font class="process-col">{row.processId}</font>,
        },
        {
          field: 'searchKeyValue1',
          title: 'Search Key Value 1',
          key: 'searchKeyValue1',
          width: 250,
          renderBodyCell: ({ row, column, rowIndex }, h) => (
            <font>{row.record.searchKeyValue1}</font>
          ),
        },
        {
          field: 'searchKeyValue2',
          title: 'Search Key Value 2',
          key: 'searchKeyValue2',
          width: 250,
          renderBodyCell: ({ row, column, rowIndex }, h) => (
            <font>{row.record.searchKeyValue2}</font>
          ),
        },
        {
          field: 'transInputSize',
          title: 'Source File Size',
          key: 'transInputSize',
          width: 130,
          renderBodyCell: ({ row, column, rowIndex }, h) => (
            <font>{row.record.transInput.fileSize}</font>
          ),
        },
        {
          field: 'transOutputSize',
          title: 'Target File Size',
          key: 'transOutputSize',
          width: 130,
          renderBodyCell: ({ row, column, rowIndex }, h) => (
            <font>{row.record.transOutput.fileSize}</font>
          ),
        },
        {
          field: 'processSetupName',
          title: 'Setup Name',
          key: 'processSetupName',
          width: 350,
          renderBodyCell: ({ row, column, rowIndex }, h) => (
            <a class='link-file-text cursor-pointer' on-click={() => this.openProcessWindow(row)}>
              <u>{row.processSetupName}</u>
            </a>
          ),
        },
        {
          field: 'bizFileBackupId',
          title: 'Biz. File',
          key: 'bizFileBackupId',
          width: 100,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return row.record.transOutput.bizFileBackupId !== '' ? (
              <a
                class='link-file-text cursor-pointer layout-col'
                on-click={() =>
                  this.openMonitoringBizFileViewWindow(row.record.transOutput.bizFileBackupId, row)
                }
              >
                {this.$t('btn.common.view')}
              </a>
            ) : (
              ''
            );
          },
        },
        {
          field: 'sourceFileName',
          title: 'Input File Name',
          key: 'sourceFileName',
          width: 700,
          renderBodyCell: ({ row, column, rowIndex }, h) => (
            <font>{row.record.sourceFileName}</font>
          ),
        },
        {
          field: 'targetFileName',
          title: 'Output File Name',
          key: 'targetFileName',
          width: 700,
          renderBodyCell: ({ row, column, rowIndex }, h) => (
            <font>{row.record.targetFileName}</font>
          ),
        },
      ],
      cellStyleOption: {
        headerCellClass: ({ column, rowIndex }) => {
          if (['CHECK'].includes(column.key)) {
            return 'pl-2';
          }
        },
        bodyCellClass: ({ row, column, rowIndex }) => {
          if (
            ['senderId', 'recipientId', 'messageName', 'sourceFileName', 'targetFileName'].includes(
              column.key,
            )
          ) {
            return 'left-cell pl-2';
          }
          if (['CHECK'].includes(column.key)) {
            return 'pl-2';
          }
        },
      },
      rowStyleOption: {
        stripe: true,
      },
      cellSelectionOption: {
        enable: false,
      },
      columnHiddenOption: {
        // default hidden column keys
        defaultHiddenColumnKeys: ['searchKeyValue2'],
      },
      checkboxOption: {
        selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
          if (selectedRowKeys.length > 0) {
            this.checkReprocess = false;
            const filterKey = this.listData.filter((e) => selectedRowKeys.includes(e.KEY))
            this.selectItems = [...filterKey];
          } else {
            this.checkReprocess = true;
            this.selectItems = [];
          }
        },
        selectedAllChange: ({ isSelected }) => {
          this.checkReprocess = !isSelected;
          this.selectItems = isSelected ? [...this.listData] : [];
        },
      },
      columnResizeInfo: {
        column: '',
        differWidth: '',
        columnWidth: '',
        tableWidth: '',
      },
      columnWidthResizeOption: {
        // default false
        enable: true,
        // column resize min width
        minWidth: 30,
        // column size change
        sizeChange: ({ column, differWidth, columnWidth }) => {
          this.columnResizeInfo.column = column;
          this.columnResizeInfo.differWidth = differWidth;
          this.columnResizeInfo.columnWidth = columnWidth;
        },
      },
      listData: [],
      editedIndex: -1,
      statuses: [
        { text: this.$t('lbl.common.conditionSearch.all'), value: '' },
        { text: 'PROCESSING', value: 'PROCESSING' },
        { text: 'PROCESSING(Re-Trans)', value: 'PROCESSING(Re-Trans)' },
        { text: 'SENT', value: 'DONE' },
        { text: 'SENT(Re-Trans)', value: 'SENT(Re-Trans)' },
        { text: 'ERROR', value: 'ERROR' },
      ],
      directions: [
        { text: this.$t('lbl.common.conditionSearch.all'), value: '' },
        { text: 'INBOUND', value: 'I' },
        { text: 'OUTBOUND', value: 'O' },
      ],
      EDIMesList: [],
      searchByItems: [
        { text: this.$t('lbl.common.searchTypePlaceHolder'), value: 'all' },
        { text: 'Sender', value: 'senderId' },
        { text: 'Receiver', value: 'recipientId' },
        { text: 'Message', value: 'messageName' },
        { text: 'Partner', value: 'partnerId' },
        { text: 'Setup Name', value: 'processSetupName' },
      ],
      searchKeyByItems: [
        { text: 'Process ID', value: 'processId' },
        { text: 'Input Filename', value: 'inputFileName' },
        { text: 'Output Filename', value: 'outputFileName' },
      ],
      fromDateData: getAppliedTimeZone(),
      fromDate: false,
      fromTimeData: '00:00',
      fromTime: false,
      toDateData: getAppliedTimeZone(),
      toDate: false,
      toTimeData: '23:59',
      toTime: false,
      company: null, // 2021.6.10 163189 SKPA-134: Remove default
      userId: '',
      gmtTmzn: '',
      partner: '',
      senderId: '',
      recipientId: '',
      status: null, // 2021.6.10 163189 SKPA-134: Remove default
      direction: null, // 2021.6.10 163189 SKPA-134: Remove default
      message: [],
      processSetupName: null, // 2021.6.10 163189 SKPA-134: Remove default,
      processSetupId: null, // 2021.6.10 163189 SKPA-134: Remove default,
      messageReferenceId: '',
      messageDirecion: '',
      proTitle: '',
      processData: {},
      tmpInputFileLink: '',
      tmpOutputFileLink: '',
      tmpOutputBizFileLink: '',
      tmpItem: [],
      tempDataInfo: [],
      searchBy: 'all',
      searchByTxt: '',
      searchKeyBy1: 'processId', // 2021.10.11 203728 SPKA-234 set processId to default
      searchKeyBy2: '',
      searchKeyByTxt1: this.$route.query.processId || '',
      searchKeyByTxt2: '',
      page: 1,
      pageEnter: 1, // 2021.11.23 203728 SPKA-260 input value page number
      pageCount: 0,
      isFilter: false,
      isAddFilter: false,
      itemsPerPage: 100,
      rowPerPage: [
        { value: 10, text: 'Show 10' },
        { value: 25, text: 'Show 25' },
        { value: 50, text: 'Show 50' },
        { value: 75, text: 'Show 75' },
        { value: 100, text: 'Show 100' },
      ],
      compOrgList: [],
      customerItem: [{ text: this.$t('lbl.common.conditionSearch.all'), value: '' }], // 2021.3.23 203728 SPKA-56
      processSetupNameList: [{ text: this.$t('lbl.common.conditionSearch.all'), value: '' }],
      hash: '',
      checkDialogColor: 'success',
      checkDialogTitle: '',
      checkDialogInfo: '',
      processViewArr: [],
      allSrchKeyList: [],
      isLoading: true,
      dataInfo: {},
      dataSort: {},
      excelWarningContent: '',
      paramSearch: {},
      selectItems: [],
      checkReprocess: true,
      reProcessContent: '',
      selectReprocess: [],
      search: '',
      isFocus: false,
    };
  },

  computed: {
    ...mapState('common', {
      CommMsgList: 'CommMsgList',
      sysloadingTitle: 'sysloadingTitle',
    }),
    getProcessSetupNameList() {
      return this.processSetupNameList;
    },
    getMaxDate() {
      return getAppliedTimeZone();
    },
    getMinDate() {
      return this.fromDateData;
    },
    filteredOptions() {
      return this.searchKeyByItems.filter(
        (e) => e.value !== 'processId' && e.value !== this.searchKeyBy1,
      );
    },
  },
  watch: {
    page() {
      this.pageEnter = this.page;
    },
    isAddFilter() {
      if (this.isAddFilter) {
        this.showColumns(['searchKeyValue2']);
      } else {
        this.hideColumns(['searchKeyValue2']);
      }
    },
  },
  methods: {
    // hidden columns
    hideColumns(keys) {
      this.$refs['ve-monitor-list'].hideColumnsByKeys(keys);
    },
    // show cloumns
    showColumns(keys) {
      this.$refs['ve-monitor-list'].showColumnsByKeys(keys);
    },
    removeChip(index) {
      const newArr = [...this.message];
      newArr.splice(index, 1);
      this.message = newArr;
    },
    openAddFilter() {
      this.isAddFilter = true;
    },
    deleteAddFilter() {
      this.searchKeyBy2 = '';
      this.searchKeyByTxt2 = '';
      this.isAddFilter = false;
    },
    displaySearchConditions(action) {
      if (action === 'expand') {
        $('.date-query-section').css('display', 'block');
        $('.data-query-section').css('display', 'block');
        $('.expand-search-conditions').css('display', 'none');
        $('.collapse-search-conditions').css('display', 'block');
      } else {
        $('.date-query-section').css('display', 'none');
        $('.data-query-section').css('display', 'none');
        $('.expand-search-conditions').css('display', 'block');
        $('.collapse-search-conditions').css('display', 'none');
      }
    },
    validateTimeInput(side) {
      let timeString = side === 'from' ? this.fromTimeData : this.toTimeData;
      let isValid = /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/.test(timeString);
      if (!isValid) {
        this.$refs.validateDate.dialog = true;
        side === 'from' ? (this.fromTimeData = '00:00') : (this.toTimeData = '23:59');
      }
    },
    validateDateInput(dateString) {
      let regEx = /^\d{4}-\d{2}-\d{2}$/;
      if (!dateString.match(regEx)) return false; // Invalid format
      let d = new Date(dateString);
      let dNum = d.getTime();
      if (!dNum && dNum !== 0) return false; // NaN value, Invalid date
      return d.toISOString().slice(0, 10) === dateString;
    },
    formatDate(side, evt) {
      let dateString = side === 'from' ? this.fromDateData : this.toDateData;
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46 && charCode !== 45) {
        evt.preventDefault();
      } else if (
        (charCode !== 46 &&
          charCode !== 8 &&
          charCode !== 45 &&
          dateString.length === 4 &&
          !dateString.includes('-')) ||
        (charCode !== 46 &&
          charCode !== 8 &&
          charCode !== 45 &&
          dateString.length === 7 &&
          dateString[4] === '-' &&
          (dateString.match(/-/g) || []).length == 1)
      ) {
        dateString += '-';
        side === 'from' ? (this.fromDateData = dateString) : (this.toDateData = dateString);
      } else {
        return true;
      }
    },
    formatTime(side, evt) {
      let timeString = side === 'from' ? this.fromTimeData : this.toTimeData;
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46 &&
        charCode !== 45 &&
        charCode !== 58
      ) {
        evt.preventDefault();
      } else if (
        charCode !== 46 &&
        charCode !== 8 &&
        charCode !== 58 &&
        timeString.length === 2 &&
        !timeString.includes(':')
      ) {
        timeString += ':';
        side === 'from' ? (this.fromTimeData = timeString) : (this.toTimeData = timeString);
      } else {
        return true;
      }
    },
    changeDate(side) {
      if (side === 'from') {
        if (!this.validateDateInput(this.fromDateData)) {
          this.$refs.validateDate.dialog = true;
          this.fromDateData = getAppliedTimeZone();
          this.toDateData = getAppliedTimeZone();
          return;
        }
        if (this.fromDateData > getAppliedTimeZone()) {
          this.fromDateData = getAppliedTimeZone();
        }
        if (this.fromDateData > this.toDateData) {
          this.toDateData = this.fromDateData;
        }
      }
      if (side === 'to') {
        if (!this.validateDateInput(this.toDateData)) {
          this.$refs.validateDate.dialog = true;
          this.toDateData = getAppliedTimeZone();
          this.fromDateData = getAppliedTimeZone();
          return;
        }
        if (this.toDateData > getAppliedTimeZone()) {
          this.toDateData = getAppliedTimeZone();
        }
        if (this.fromDateData > this.toDateData) {
          this.fromDateData = this.toDateData;
        }
      }
    },
    async downOriginMulti() {
      const data = [];
      const _self = this;
      await Promise.all(
        _self.selectItems.map(async (e) => {
          const inputFilePath = `${e.record.transInput.fileLink}`;
          const originFileName = `${e.data.payload.userData.fileName}`;
          await _self.$store.dispatch('getinputFileContens', inputFilePath).then(() => {
            if (_self.$store.getters.inputFileContents != null) {
              let rslt = _self.$store.getters.inputFileContents;
              return data.push({ result: rslt, title: originFileName });
            }
          });
        }),
      );

      if (data.length > 1) {
        this.zipFiles(data);
      } else if (data.length == 1) {
        this.downloadFileView(data[0].result, data[0].title);
      }
    },
    downloadFileView(content, title) {
      let data = new Blob([content], { type: 'text/plain' });
      let url = window.URL.createObjectURL(data);

      let a = document.createElement('a');
      a.href = url;
      a.download = title;
      document.body.appendChild(a);
      a.click();
    },
    async zipFiles(data) {
      let JSZip = require('jszip');
      const zip = new JSZip();
      data.map((e) => {
        const file1 = new Blob([e.result], { type: 'text/plain' });
        zip.file(e.title, file1);
      });

      const content = await zip.generateAsync({ type: 'blob' });
      this.saveAs(content, 'OriginFiles.zip');
    },
    saveAs(content, fileName) {
      const a = document.createElement('a');
      const isBlob = content.toString().indexOf('Blob') > -1;
      let url = content;
      if (isBlob) {
        url = window.URL.createObjectURL(content);
      }
      a.href = url;
      a.download = fileName;
      a.click();
      if (isBlob) {
        window.URL.revokeObjectURL(url);
      }
    },
    reProcesMulti() {
      this.$store
        .dispatch('execReTranslation', {
          data: this.selectItems.map((e) => e.data),
        })
        .then(() => {
          this.reProcessContent = 'ReTranslation is complete.';
          this.$refs.reProcess.dialog = true;
        });
    },
    closeWindow(type) {
      const message = {
        message: type,
      };
      if (window.opener && !window.opener.closed) {
        window.opener.postMessage(message, '*');
      }

      setTimeout(() => {
        window.close();
      }, 50);
    },

    getMapList() {
      const masterSearchItems = {
        header: ['ADMIN_YN', 'CUST_ID'],
        data: [
          {
            ADMIN_YN: this.$cookies.get('user-admin-yn'),
            CUST_ID: this.$cookies.get('comp-id'),
          },
        ],
      };
      Store.dispatch('map/queryMapListByProcSetup', masterSearchItems);
    },
    changePageByTextbox(value) {
      let data = parseInt(this.pageEnter);
      if (isNaN(data)) {
        this.pageEnter = this.page;
        return;
      } else {
        this.page = data > this.pageCount ? this.pageCount : data < 1 ? 1 : data;
        this.pageEnter = this.page;
      }
      this.page += value;
      this.initialize('pageChange');
    },
    removeSpaceCommo(inputString) {
      inputString = inputString.replace(/,,/g, '');
      if (inputString.substr(inputString.length - 1) == ',')
        inputString = inputString.substring(0, inputString.length - 1);
      return inputString;
    },
    sortChange(data) {
      this.dataSort = data;
      let keys = Object.keys(data);
      for (let i = 0; i < keys.length; i++) {
        let col = keys[i];
        let sort = data[col];
        if (sort != '') {
          Store.commit('sortmonitoringList', { col, sort });
          this.listData = this.$store.getters.monitoringList;
          return;
        }
      }
    },
    setSearchKeyByTxt(item) {
      if(item !== '' || item !== null || item !== undefined) {
        let inputString = item;
        inputString = inputString.replace(/\r/g, '');
        inputString = inputString.replace(/\n+/g, '\n');
        inputString = inputString.replace(/^\n|\n$/g, '');
        inputString = inputString.replace(/\n/g, ',');

        inputString = this.removeSpaceCommo(inputString);
        this.searchKeyByTxt1 = inputString;
      }
    },
    openProcessWindow(item) {
      const isHistory = true;
      const type = 'History';

      let processArray = item.processSetupId.split('-');
      let versionNo = 0.1;
      if (processArray.length > 1) {
        versionNo = processArray[1] / 10;
      }

      const params = {
        ROWID: processArray[0].toString(),
        type: type,
        options: {
          dataValue: processArray[0],
          id: processArray[0].toString(),
          isHistory: isHistory,
          versionNo: versionNo.toString(),
          fromTransaction: true,
          auth: this.$auth,
        },
      };
      item.id = processArray[0];
      const arrView = {
        item,
        type,
      };
      const url = `/process/workflowDetailNew/${type}/${params.ROWID}/${params.options.versionNo}`;
      const size = 'width=1800,height=930,left=60,top=20';
      openWindow({
        arrView,
        url: url,
        params,
        size: size,
      });
    },
    findIndexItem(arrView, arr, col) {
      let prop = typeof col == 'undefined' ? 'id' : col;
      let index = arr.findIndex((row) => {
        return row.item[prop] === arrView.item[prop] && row.type === arrView.type;
      });
      return index > -1 ? index : null;
    },
    handlePageChange(value) {
      this.page = value;
      this.initialize('pageChange');
    },

    handlePageSizeChange(size) {
      this.itemsPerPage = size;
      this.page = 1;
      this.initialize();
    },
    initialize(pageChange) {
      if (this.isAddFilter) {
        if (this.searchKeyByTxt2.includes(',')) {
          this.$refs.excelValidation.dialog = true;
          this.excelWarningContent = 'Cannot input multiple value in Search Key 2';
          return;
        }
      }
      this.selectItems = [];
      this.selectReprocess = [];
      this.isLoading = true;
      if(this.searchKeyByTxt1 !== undefined || this.searchKeyByTxt1 !== null || this.searchKeyByTxt1 !== '') {
        this.searchKeyByTxt1 = this.removeSpaceCommo(this.searchKeyByTxt1);
      }
      if (
        dateValidation(deleteDateFormatStr(this.fromDateData), deleteDateFormatStr(this.toDateData))
      ) {
        this.paramSearch = this.getParamData(pageChange);
        if (!this.paramSearch.dateCond && this.paramSearch.srchKeyVal == '') {
          this.isLoading = false;
          this.$refs.Validation.dialog = true;
          this.checkDialogColor = 'validation';
          this.checkDialogTitle = 'Search';
          this.checkDialogInfo = this.$t('msg.common.searchConditionValidate');
        } else {
          this.$store
            .dispatch('getMonitoringList', this.paramSearch)
            .then(() => {
              let data = this.$store.getters.monitoringList || [];
              const processedData = data.map((item, index) => {
                if (!item) return {};
                const safeProcessId = item.processId || 'unknown';
                const rowNumber = (this.page - 1) * this.itemsPerPage + index + 1;
                return {
                  ...item,
                  KEY: `${safeProcessId}_${rowNumber}`
                }
              });
              this.$nextTick(() => {
                this.listData = processedData;
              });
              if (this.$store.getters.totalCnt % this.itemsPerPage === 0) {
                this.pageCount = this.$store.getters.totalCnt / this.itemsPerPage;
              } else {
                this.pageCount = Math.floor(this.$store.getters.totalCnt / this.itemsPerPage) + 1;
              }
              if (pageChange == 'pageChange' && this.pageCount < this.page) {
                this.page = 1;
              }
              this.searchByTxt = '';
              this.searchBy = 'all';
              this.onFilterTransactionLog();
              this.isLoading = false;
            })
            .catch((ex) => {
              this.isLoading = false;
            });
        }
      } else {
        this.isLoading = false;
        this.$refs.Validation.dialog = true;
        this.checkDialogColor = 'validation';
        this.checkDialogTitle = 'Search';
        this.checkDialogInfo = this.$t('msg.common.fromDateValidate');
      }
    },
    getParamData(pageChange) {
      const params = {};
      this.userId = this.$cookies.get('user-id');
      this.gmtTmzn = this.$cookies.get('gmt-timezone');
      params.ownrId = this.$cookies.get('ownr-id');
      params.groupId = this.$cookies.get('comp-id');
      params.company = this.company == undefined || this.company == null ? '' : this.company; // 2021.6.10 163189 SKPA-134: Remove default,
      params.userId = this.userId;
      params.senderId = this.senderId;
      params.recipientId = this.recipientId;
      params.partner = this.partner;

      params.message =
        this.message == undefined || this.message.length === 0 ? '' : this.message.join(',');

      params.status = this.status == undefined || this.status == null ? '' : this.status; // 2021.6.10 163189 SKPA-134: Remove default,
      params.fromDateData = this.applyGmtTimeZoneForSrchcond(
        this.fromDateData + ' ' + this.fromTimeData,
      );
      params.toDateData = this.applyGmtTimeZoneForSrchcond(this.toDateData + ' ' + this.toTimeData);
      params.processSetupId =
        this.processSetupId == undefined || this.processSetupId == null ? '' : this.processSetupId; // 2021.6.10 163189 SKPA-134: Remove default,
      params.messageReferenceId = this.messageReferenceId;
      params.messageDirection =
        this.direction == undefined || this.direction == null ? '' : this.direction; // 2021.6.10 163189 SKPA-134: Remove default,
      params.srchKey1 =
        this.searchKeyBy1 == undefined || this.searchKeyBy1 == null ? '' : this.searchKeyBy1; // 2021.6.10 163189 SKPA-134: Remove default,
      params.srchKey2 =
        this.searchKeyBy2 == undefined || this.searchKeyBy2 == null ? '' : this.searchKeyBy2;
      params.srchKeyVal1 =
        this.searchKeyByTxt1 == undefined || this.searchKeyByTxt1 === null || this.searchKeyByTxt1 === ''
          ? ''
          : this.searchKeyByTxt1.trim() === ''
          ? ''
          : this.searchKeyByTxt1; // 2021.6.10 163189 SKPA-134: Remove default,
      params.srchKeyVal2 =
        this.searchKeyByTxt2 == undefined || this.searchKeyByTxt2 == null || this.searchKeyByTxt2 === ''
          ? ''
          : this.searchKeyByTxt2.trim() === ''
          ? ''
          : this.searchKeyByTxt2;
      params.dateCond = this.dateCond;

      params.direction =
        this.direction == undefined || this.direction == null ? '' : this.direction; // 2021.6.10 163189 SKPA-134: Remove default,

      if (typeof pageChange == 'undefined' || pageChange != 'pageChange') {
        this.page = 1;
      }
      params.page = this.page;
      params.perPage = this.itemsPerPage;

      return params;
    },
    checkEditData(formData, loadFormData) {
      let keyArr = Object.keys(loadFormData);
      let checkEdit = false;
      for (let i = 0; i < keyArr.length; i++) {
        if (formData[keyArr[i]] !== loadFormData[keyArr[i]]) {
          checkEdit = true;
          break;
        }
      }
      return checkEdit;
    },
    downloadExcel() {
      let param = this.getParamData();
      if (this.checkEditData(param, this.paramSearch)) {
        this.$refs.excelValidation.dialog = true;
        this.excelWarningContent = 'Please search first and try again.';
        return;
      }
      if (this.listData.length === 0) {
        this.$refs.excelValidation.dialog = true;
        this.excelWarningContent =
          'There is no data to download. Pleae try again after search data.';
        return;
      }
      this.isLoading = true;
      this.$store
        .dispatch('getMonitoringExcelData', this.paramSearch)
        .then((res) => {
          this.generateExcelFile(res);
          this.isLoading = false;
        })
        .catch((ex) => {
          this.isLoading = false;
        });
    },
    generateExcelFile(excelData) {
      const excel = require('node-excel-export');
      // You can define styles as json object
      const styles = {
        headerDark: {
          fill: {
            fgColor: {
              rgb: 'FF496D94',
            },
          },
          font: {
            color: {
              rgb: 'FFFFFFFF',
            },
            sz: 14,
          },
        },
      };

      // Sender ID	Receiver ID	  Msg Type	    Msg Status	      Rcv Date	      Trans Date	    Sent Date	      Search Key Value	Input File Size	  Output File Size	Source File Name	  Target File Name
      // senderId	  recipientId	  messageName	  transactionCode	  recvTimestamp	  transTimestamp	sentTimestamp	  searchKeyValue	  inputFileSize	    outputFileSize	  sourceFileName	    targetFileName
      // 110        110           110           120               180             180             180             250               110               110               700                 700

      //Here you specify the export structure
      const specification = {
        senderId: {
          // <- the key should match the actual data key
          displayName: 'Sender ID', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 110, // <- width in pixels
        },
        recipientId: {
          // <- the key should match the actual data key
          displayName: 'Receiver ID', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 110, // <- width in pixels
        },
        messageName: {
          // <- the key should match the actual data key
          displayName: 'Msg Type', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 110, // <- width in pixels
        },
        transactionCode: {
          // <- the key should match the actual data key
          displayName: 'Msg Status', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          // cellFormat: function(value, row) { // <- Renderer function, you can access also any row.property
          //   let item = self.srmStatusArr.find((item) => { return item.value == value})
          //   return item ? item.text : '';
          // },
          width: 120, // <- width in pixels
        },
        recvTimestamp: {
          // <- the key should match the actual data key
          displayName: 'Rcv Date', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 180, // <- width in pixels
        },
        transTimestamp: {
          // <- the key should match the actual data key
          displayName: 'Trans Date', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 180, // <- width in pixels
        },
        sentTimestamp: {
          // <- the key should match the actual data key
          displayName: 'Sent Date', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 180, // <- width in pixels
        },
        // item.processId;
        processId: {
          // <- the key should match the actual data key
          displayName: 'Process ID', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 180, // <- width in pixels
        },
        searchKeyValue1: {
          // <- the key should match the actual data key
          displayName: 'Search Key Value 1', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 250, // <- width in pixels
        },
        searchKeyValue2: {
          // <- the key should match the actual data key
          displayName: 'Search Key Value 2', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 250, // <- width in pixels
        },
        inputFileSize: {
          // <- the key should match the actual data key
          displayName: 'Input File Size', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 110, // <- width in pixels
        },
        outputFileSize: {
          // <- the key should match the actual data key
          displayName: 'Output File Size', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 110, // <- width in pixels
        },
        sourceFileName: {
          // <- the key should match the actual data key
          displayName: 'Source File Name', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 700, // <- width in pixels
        },
        targetFileName: {
          // <- the key should match the actual data key
          displayName: 'Target File Name', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 700, // <- width in pixels
        },
      };

      // Create the excel report.
      // This function will return Buffer
      const report = excel.buildExport([
        // <- Notice that this is an array. Pass multiple sheets to create multi sheet report
        {
          name: 'Report', // <- Specify sheet name (optional)
          heading: [], // <- Raw heading array (optional)
          merges: [], // <- Merge cell ranges
          specification: specification, // <- Report specification
          data: excelData, // <-- Report data
        },
      ]);

      let data = new Blob([report.buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      let url = window.URL.createObjectURL(data);
      let a = document.createElement('a');
      a.href = url;
      a.download = 'Transaction_log.xlsx';
      document.body.appendChild(a);
      a.click();
    },

    addDays(date, days) {
      let result = moment(date)
        .add(days, 'd')
        .format('YYYY-MM-DD');
      return result;
    },

    applyGmtTimeZone(date) {
      let newM = '';
      if (date !== undefined && date !== '') {
        newM = moment(date)
          .add(this.gmtTmzn, 'hours')
          .format('YYYY-MM-DD HH:mm:ss');
      }
      return newM;
    },

    applyGmtTimeZoneForSrchcond(date) {
      let newM = '';
      let timezone = Number(this.gmtTmzn[1] + this.gmtTmzn[2]);
      if (date !== undefined && date !== '') {
        if (this.gmtTmzn.indexOf(`+`) === 0) {
          newM = moment(date)
            .subtract(timezone, 'hours')
            .format('YYYY-MM-DD HH:mm:ss');
        }
        if (this.gmtTmzn.indexOf(`-`) === 0) {
          newM = moment(date)
            .add(timezone, 'hours')
            .format('YYYY-MM-DD HH:mm:ss');
        }
      }
      return newM;
    },

    closeFileView() {
      this.dialogFileView = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    statusColor(status, processCode) {
      if (status.indexOf('SEND_O_DONE') !== -1 && processCode == 'finalDestination') return '#497DDE';
      else if (status.indexOf('FAIL') !== -1) return '#FF7B7A';
      else if (status.indexOf(undefined) !== -1) return '#FF7B7A';
      else return '#5BC5F1';
    },

    statusText(status, reprocessState, processCode) {
      let reProcSts = '';
      if (reprocessState === 'S') reProcSts = ' (Re-Send)';
      else if (reprocessState === 'T') reProcSts = ' (Re-Trans)';

      if (status.indexOf('SEND_O_DONE') !== -1 && processCode == 'finalDestination') return `Sent${reProcSts}`;
      else if (status.indexOf('FAIL') !== -1) return `Error${reProcSts}`;
      else if (status.indexOf(undefined) !== -1) return `Unknown${reProcSts}`;
      else return `Processing${reProcSts}`;
    },

    directionText(direction) {
      if (direction === 'I') return 'Inbound';
      else if (direction === 'O') return 'Outbound';
    },

    weekdayColor(a) {
      let week = new Date(a).getDay();

      if (week == 0) {
        return 'Sun';
      } else if (week == 1) {
        return 'Mon';
      } else if (week == 2) {
        return 'Tue';
      } else if (week == 3) {
        return 'Wed';
      } else if (week == 4) {
        return 'Thu';
      } else if (week == 5) {
        return 'Fri';
      } else if (week == 6) {
        return 'Sat';
      }
    },
    openMonitoringDateValidationWindow() {
      let type = 'dialogWindow';
      let item = {
        ROWID: 0,
      };
      let indexArrDialog = this.findDialog('openMonitoringDateValidationWindow_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    openMonitoringFileViewWindow(item) {
      const type = 'ProcessedFile';

      const params = {
        ROWID: item.processId.toString(),
        type: type,
        options: {
          dataValue: item,
          id: item.processId.toString(),
          auth: this.$auth,
        },
      };

      item.id = item.processId;
      const arrView = {
        item,
        type,
      };
      const url = `/monitoring/monitoringFileView/${type}/${params.ROWID}`;
      const size = 'width=1100,height=812,left=250,top=20';
      openWindow({
        arrView,
        url: url,
        params,
        size: size,
      });
    },
    openMonitoringBizFileViewWindow(outputBizFileLink, rowItem) {
      let type = 'monitoringBizFileViewWindow';
      this.tmpOutputBizFileLink = outputBizFileLink;
      this.tempItem = rowItem;
      let item = {
        ROWID: 0,
        data: rowItem,
      };
      let indexArrDialog = this.findDialog('monitoringBizFileViewWindow_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    changeDateTime() {
      if (this.dateCond) {
        this.fromDateData = getAppliedTimeZone();
        this.fromTimeData = '00:00';
        this.toDateData = getAppliedTimeZone();
        this.toTimeData = '23:59';
      } else {
        this.fromDateData = '';
        this.fromTimeData = '';
        this.toDateData = '';
        this.toTimeData = '';
      }
    },
    changeKeyBy() {
      if (
        this.searchKeyBy1 == 'processId' ||
        this.searchKeyBy1 == 'inputFileName' ||
        this.searchKeyBy1 == 'outputFileName'
      ) {
        this.deleteAddFilter();
      }
      if (this.searchKeyBy1 !== 'processId') {
        this.checkSearchKeyBy = true;
        if (!this.dateCond) {
          this.dateCond = true;
          this.changeDateTime();
        }
      } else {
        this.checkSearchKeyBy = false;
      }
    },
    changeKeyBy2(event) {
      if (event.key === ',') {
        event.preventDefault();
        this.$refs.excelValidation.dialog = true;
        this.excelWarningContent = 'Cannot input multiple value in Search Key 2';
      }
    },
    openMonitoringStateViewWindow(item) {
      const type = 'StateView';
      const params = {
        ROWID: item.processId.toString(),
        type: type,
        options: {
          dataValue: item,
          id: item.processId.toString(),
          auth: this.$auth,
        },
      };
      item.id = item.processId;
      const arrView = {
        item,
        type,
      };
      const url = `/monitoring/monitoringStateView/${type}/${params.ROWID}`;
      const size = 'width=1200,height=725,left=120,top=50';
      openWindow({
        arrView,
        url: url,
        params,
        size: size,
      });
    },

    openInputSearchKeyWindow() {
      let type = 'inputSearchKeyWindow';
      this.searchKeyByTxt1 = this.searchKeyByTxt1 !== undefined || this.searchKeyByTxt1 !== null || this.searchKeyByTxt1 !== '' ? this.removeSpaceCommo(this.searchKeyByTxt1) : '';
      this.tempItem = this.searchKeyByTxt1.replace(/,/g, '\n');
      let item = {
        ROWID: 0,
        data: this.searchKeyByTxt1,
      };
      let indexArrDialog = this.findDialog('inputSearchKeyWindow_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    findDialog(id, dialogs) {
      if (!dialogs) dialogs = this.dialogs;
      let index = dialogs.findIndex((val) => {
        return val.id === id;
      });
      return index > -1 ? index : null;
    },
    newDialog(item, type) {
      return this.dialogs.push(this.generateDialog(item, type));
    },
    generateDialog(item, type) {
      let id = `${type}_${item.ROWID}`;
      this.arrLayoutDialog.push({ id: id });
      this.dialogId++;
      let name = 'Dialog ' + id;
      let options = { left: 30 * this.dialogId, top: 30 * this.dialogId, item };
      return { id, name, type, options };
    },
    removeDialog(dialog) {
      let id = dialog.id;
      let index = this.findDialog(id);
      let indexArrDialog = this.findDialog(id, this.arrLayoutDialog);
      this.arrLayoutDialog.splice(indexArrDialog, 1);
      this.dialogs.splice(index, 1);
      if (this.selected && this.selected.id === id) this.selected = null;
    },
    dialogDragEnd(obj) {
      let index = this.findDialog(obj.id);
      this.$set(this.dialogs[index].options, 'left', obj.left);
      this.$set(this.dialogs[index].options, 'top', obj.top);
    },
    selectDialog(obj) {
      let index = this.findDialog(obj.id);
      this.selected = this.dialogs[index];
    },
    changeMsgCode() {
      this.search = '';
      this.searchKeyByItems = [
        { text: 'Process ID', value: 'processId' },
        { text: 'Input Filename', value: 'inputFileName' },
        { text: 'Output Filename', value: 'outputFileName' },
      ];
      if (this.message.length === 0) {
        this.searchKeyBy1 = 'processId';
        this.searchKeyByTxt1 = '';
        this.changeKeyBy();
        let getUniqueListBy = function(arr, key) {
          return [...new Map(arr.map((item) => [item[key].trim(), item])).values()];
        };
        let arr1 = getUniqueListBy(this.allSrchKeyList, 'srchKeyItem');
        arr1 = arr1.sort(function(a, b) {
          return b.srchKeyItem < a.srchKeyItem ? 1 : -1;
        });
        for (let i = 0; i < arr1.length; i++) {
          let SKeyObj = {};
          SKeyObj.text = arr1[i].srchKeyItem;
          SKeyObj.value = arr1[i].srchKeyItem;
          this.searchKeyByItems.push(SKeyObj);
        }
      } else {
        this.searchKeyBy1 = 'processId';
        this.searchKeyByTxt1 = '';
        this.isAddFilter = false;
        this.searchKeyBy2 = '';
        this.searchKeyByTxt2 = '';
        const filterItemList = this.allSrchKeyList.filter((item) =>
          this.message.includes(item.msgCd),
        );
        if (filterItemList.length > 0) {
          for (let i = 0; i < filterItemList.length; i++) {
            let SKeyObj = {};
            SKeyObj.text = filterItemList[i].srchKeyItem;
            SKeyObj.value = filterItemList[i].srchKeyItem;
            this.searchKeyByItems.push(SKeyObj);
          }
        }
      }
    },
    getSearchKeyList() {
      let params = {
        srcSrchKeyItem: '',
        srcMsgCd: '',
      };

      this.$store.dispatch('getSearchKeyList', params).then(() => {
        this.allSrchKeyList = this.$store.getters.srchKeyList;
        this.changeMsgCode();
      });
    },
    getEDIMsgTypeList() {
      let commMsgSearchItems = {
        header: ['MSG_NM'],
        data: [
          {
            MSG_NM: '',
          },
        ],
      };
      Store.dispatch('common/getCommonMessageList', commMsgSearchItems).then(() => {
        for (let i = 0; i < this.CommMsgList.length; i++) {
          let EDIVerObj = {};
          EDIVerObj.text = this.CommMsgList[i].MSG_CD + ' (' + this.CommMsgList[i].MSG_NM + ')';
          EDIVerObj.value = this.CommMsgList[i].MSG_CD;
          this.EDIMesList.push(EDIVerObj);
        }
      });
    },

    onFilterTransactionLog(isFilter) {
      this.isFilter = true;
      if (this.searchBy == 'all' && this.searchByTxt == '') {
        this.isFilter = false;
      }
      Store.commit('SET_STORE_TRANSACTION_LOG_FILTER', {
        filter: this.searchBy,
        str: this.searchByTxt,
      });
      this.listData = this.$store.getters.monitoringList;
      this.sortChange(this.dataSort);
    },
    allowedDates(val) {
      let date = getAppliedTimeZone();
      if (val <= date) {
        return val;
      }
    },
    closeDialog() {
      this.$refs.Validation.dialog = false;
    },
  },

  created() {
    if (this.$route.query.auth_token) {
      this.isLoading = false;
      const url =
        this.$route.path +
        '/token?auth_token=' +
        this.$route.query.auth_token +
        '&processId=' +
        this.$route.query.processId;
      this.$router.push(url);
      return;
    }
    this.dateTimeFormat = config.dateTimeFormat;
    this.hash = $cookies.get('hash');
    if (this.$route.query.processId) {
      this.dateCond = false;
      this.changeDateTime();
    }

    this.$store.dispatch('getApiCompanyList').then(() => {
      this.$store.getters.apicompanies.forEach((element) => {
        let codeObj = {};
        codeObj.text = element.compNm;
        codeObj.value = element.compId;
        this.customerItem.push(codeObj);
      });
    });
    this.$store
      .dispatch('getProcessSetupList')
      .then(() => {
        const tmpProcessSetupList = this.$store.getters.processSetupList;
        for (let i = 0; i < tmpProcessSetupList.length; i += 1) {
          const tmpProcessSetup = tmpProcessSetupList[i];
          const tmp = {
            text: tmpProcessSetup.processSetupName,
            value: tmpProcessSetup.processSetupId,
          };
          this.processSetupNameList.push(tmp);
        }
      })
      .catch((ex) => {
        this.isLoading = false;
      });

    this.getEDIMsgTypeList();
    this.getSearchKeyList();
    this.initialize();
    this.getMapList();
  },
};
</script>

<style scoped>
.v-application--is-ltr .v-text-field .v-input__append-inner {
  padding-right: 8px;
}
.v-table-title-cell .v-checkbox-wrapper {
  padding: 2px 16px;
}
.v-table-body-cell .v-checkbox-wrapper {
  padding: 0 17px;
}
.v-table-row .v-table-body-cell,
.v-table-header-row .v-table-title-cell,
.table-title {
  padding: 0 !important;
}
.filter-icon-add {
  cursor: pointer;
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.custom-selectbox .v-chip.v-size--small {
  height: 16px;
  font-size: 11px;
  padding: 0 6px;
}
</style>
